// Die Äpfel im Client (task-014, ADR 0031). Wie viele Äpfel am Baum hängen, sagt der Server im
// `FarmState` (`tree.apples`); der Client setzt daraufhin die Blöcke in der Krone – so viele `apfel`
// wie gemeldet, die übrigen Apfelplätze werden `laub` – und zeichnet die berührten Chunks neu. Das
// ist derselbe Weg wie beim Tor (game/tor.ts): keine eigenen Meshes, keine zweite Wahrheit.
//
// Reine Logik ohne DOM und ohne Three.js.
import { BLOCK, getBlock, parcelApfelZellen, setBlock, type Parcel, type World } from '@bauernhof/shared';
import { chunksUmBlock } from './tor.js';

/**
 * Setzt die Äpfel eines Baums: die ersten `apples` Plätze aus `parcelApfelZellen` als `apfel`, den
 * Rest als `laub`. Mehr Äpfel als Plätze füllen alle, Unbrauchbares (negativ, NaN) gilt als keiner.
 * Liefert, ob sich dabei ein Block geändert hat.
 */
export function setzeAepfel(world: World, parcel: Parcel, apples: number): boolean {
  const zellen = parcelApfelZellen(parcel);
  const anzahl = Number.isFinite(apples) ? Math.min(Math.max(Math.floor(apples), 0), zellen.length) : 0;
  let geaendert = false;
  zellen.forEach((zelle, index) => {
    const soll = index < anzahl ? BLOCK.apfel : BLOCK.laub;
    if (getBlock(world, zelle.x, zelle.y, zelle.z) === soll) return;
    setBlock(world, zelle.x, zelle.y, zelle.z, soll);
    geaendert = true;
  });
  return geaendert;
}

/** Die Chunks, deren Mesh ein Apfelplatz des Baums berührt, jeder genau einmal. */
export function chunksDerAepfel(world: World, parcel: Parcel): { cx: number; cz: number }[] {
  const chunks = new Map<string, { cx: number; cz: number }>();
  for (const zelle of parcelApfelZellen(parcel)) {
    for (const chunk of chunksUmBlock(world, zelle.x, zelle.z)) chunks.set(`${chunk.cx},${chunk.cz}`, chunk);
  }
  return [...chunks.values()];
}
